import IconTitle from './IconTitle'

export default IconTitle
